export default __webpack_public_path__ + "static/media/spaceStation6.2969c2a3.webp";